import {useReducer, useEffect} from "react"
import {LexiconsContext} from "../contexts/LexiconsContext"
import lexiconsReducer from "../reducers/lexiconsReducer"

const initialState = {
    isModal: false,
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    modalType: null,
}

export default function LexiconsProvider({children}) {
    const [lexiconsContext, setLexiconsAction] = useReducer(
        lexiconsReducer,
        initialState,
    )

    useEffect(() => {
        if (lexiconsContext) {
            localStorage.setItem("lexiconsContext", JSON.stringify(lexiconsContext))
        } else {
            localStorage.removeItem("lexiconsContext")
        }
    }, [lexiconsContext])

    return (
        <LexiconsContext.Provider value={{lexiconsContext, setLexiconsAction}}>
            {children}
        </LexiconsContext.Provider>
    )
}